function initSongbondSamples(scope=document){
/* One occasion, one example, one audio stream. All sample text exists in HTML. */
scope.querySelectorAll('[data-sample-chooser]').forEach(root => {
  if(root.dataset.homeSamplesReady)return;root.dataset.homeSamplesReady="true";
  const tabs = [...root.querySelectorAll('[data-sample-tab]')];
  const panels = [...root.querySelectorAll('[data-sample-panel]')];
  const audio = root.querySelector('[data-sb-ls-audio]');
  if (!tabs.length || tabs.length !== panels.length || !audio) return;
  let active = 0;
  let request = 0;
  let loading = false;
  const format = seconds => `${Math.floor(seconds / 60)}:${String(Math.floor(seconds % 60)).padStart(2, '0')}`;
  const current = () => panels[active];
  function paint() {
    const panel = current();
    const playing = !audio.paused && !audio.ended;
    const button = panel.querySelector('[data-sample-play]');
    button.setAttribute('aria-pressed', String(playing));
    const label = playing ? 'Pause song' : loading ? 'Loading song…' : 'Play song';
    button.setAttribute('aria-label', `${label}: ${panel.dataset.title}`);
    button.querySelector('span').textContent = label;
    const duration = audio.getAttribute('src') === panel.dataset.src && Number.isFinite(audio.duration) ? audio.duration : 0;
    const seek = panel.querySelector('[data-sample-seek]');
    seek.disabled = !duration;
    seek.max = duration || 1;
    seek.value = duration ? audio.currentTime : 0;
    seek.style.setProperty('--sb-audio-progress', `${duration ? audio.currentTime / duration * 100 : 0}%`);
    seek.setAttribute('aria-valuetext', `${format(duration ? audio.currentTime : 0)} of ${duration ? format(duration) : panel.dataset.duration}`);
    panel.querySelector('[data-sample-elapsed]').textContent = format(duration ? audio.currentTime : 0);
    panel.querySelector('[data-sample-duration]').textContent = duration ? format(duration) : panel.dataset.duration;
  }
  function select(index, focus = false) {
    request++;
    loading = false;
    audio.pause();
    audio.removeAttribute('src');
    audio.load();
    active = (index + tabs.length) % tabs.length;
    tabs.forEach((tab, i) => {
      tab.setAttribute('aria-selected', String(i === active));
      tab.tabIndex = i === active ? 0 : -1;
      panels[i].hidden = i !== active;
      panels[i].querySelector('[data-sample-feedback]').textContent = '';
    });
    if (focus) tabs[active].focus({preventScroll: true});
    paint();
  }
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => { if (active !== index) select(index); });
    tab.addEventListener('keydown', event => {
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      select(event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : active + (event.key === 'ArrowRight' ? 1 : -1), true);
    });
  });
  panels.forEach(panel => {
    panel.querySelector('[data-sample-player]').hidden = false;
    panel.querySelector('[data-sample-fallback]').hidden = true;
    panel.querySelector('[data-sample-play]').addEventListener('click', async () => {
      if (panel !== current()) return;
      if (!audio.paused || loading) { request++; loading = false; audio.pause(); paint(); return; }
      const token = ++request;
      panel.querySelector('[data-sample-feedback]').textContent = '';
      if (audio.getAttribute('src') !== panel.dataset.src) audio.src = panel.dataset.src;
      if (audio.ended) audio.currentTime = 0;
      // Listening to an example should not compete with an unmuted reaction clip.
      document.querySelectorAll('video').forEach(video => { if (!video.muted) video.pause(); });
      loading = true;
      paint();
      try {
        await audio.play();
      } catch (error) {
        if (token === request && error.name !== 'AbortError') panel.querySelector('[data-sample-feedback]').textContent = 'This song couldn’t load. Please try again.';
      } finally {
        if (token === request) { loading = false; paint(); }
      }
    });
    panel.querySelector('[data-sample-seek]').addEventListener('input', event => {
      if (panel === current() && Number.isFinite(audio.duration)) { audio.currentTime = Number(event.target.value); paint(); }
    });
  });
  ['timeupdate','loadedmetadata','pause','ended','playing','emptied'].forEach(event => audio.addEventListener(event, paint));
  document.querySelectorAll('video').forEach(video => {
    const giveVideoPriority = () => {
      if (video.muted || video.paused) return;
      request++;
      loading = false;
      audio.pause();
      paint();
    };
    video.addEventListener('volumechange', giveVideoPriority);
    video.addEventListener('play', giveVideoPriority);
  });
  audio.addEventListener('error', () => {
    if (!audio.getAttribute('src')) return;
    loading = false;
    current().querySelector('[data-sample-feedback]').textContent = 'This song couldn’t load. Please try again.';
    paint();
  });
  root.querySelector('[data-sample-tabs]').hidden = false;
  select(0);
});

}
initSongbondSamples();
document.addEventListener("shopify:section:load",event=>initSongbondSamples(event.target));
